module.exports = __webpack_public_path__ + "static/media/products_services6.ad258939.jpg";